import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const financialItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      //flexGrow: 1,
    },
    paper: {
      
      marginTop: "2em",
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
      
    },

    
    titlegap: {
      padding: "1em",
    },
    titlecolor: {
      color: "#000",
      background: "antiquewhite",
    },
    title: {
      color: "#000",
      textDecoration: "underline",
      fontWeight: "bold",
      fontSize: "16px",
      textAlign: "left",
    },
    printLeftDetail: {
      textAlign: "left",
      paddingRight: "1em",
      fontWeight: "bold",
      color: "#000",
    },
    printRightDetail: {
      textAlign: "right",
      paddingRight: "1em",
      fontWeight: "bold",
      color: "#000",      
    },
    description: {
      // paddingLeft: "2em",
      textAlign: "left",
      color: "#000",
    },
    reportTable: {
      minWidth: 450,
    },
    tableRoot: {
      width: "100%",
      overflowX: "auto",
    },

    total: {
      textAlign: "left",
      // paddingLeft: "1em",
      fontWeight: "bold",
      // paddingTop: "1em",
      color: "#000",
    },
    value: {
      textAlign: "right",
      // paddingRight: "1em",
      fontWeight: "bold",
      // paddingTop: "1em",
      color: "#000",
    },
    desptnWeight: {
      textAlign: "left",
      fontWeight: "bold",
      paddingLeft: "2em",
      color: "#000",
    },
    mart: {
      fontSize: "xx-large",
      textAlign: "left",
      paddingLeft: "1em",
      fontWeight: "bold",
      color: "#000",
    },
    report: {
      fontSize: "30px",
      textAlign: "left",

      fontWeight: "bold",
      color: "#000",
    },

    tableRow: {
      background: "white",
      color: "#a20f0f",
    },
    table: {
      minWidth: 450,
      maxWidth: 450,
    },

    tableColumn: {
      textAlign: "center",
      fontWeight: 500,
      border: "1px solid gray",
      // paddingLeft: "2em"
    },
    tableContent: {
      fontWeight: 500,
      // paddingLeft: "1em",
      border: "1px solid gray",
    },
    foreignHead: {
      color: "#800000",
      fontWeight: 500,
      // paddingRight:"1em",
      border: "1px solid gray",
    },
    voidReturnHead: {
      // paddingRight:"4em",
      fontWeight: 500,
      color: "#800000",
      border: "1px solid gray",
    },
    deptHead: {
      color: "#800000",
      fontWeight: 500,
      // paddingRight:"2.25em",
      border: "1px solid gray",
    },
    headColor: {
      color: "#000000",
      fontWeight: 500,
      border: "1px solid gray",
    },
    tablegap: {
      marginTop: "1.5em",
    },
    columnWeight: {
      fontWeight: 500,
      border: "1px solid gray",
    },
    tablecontentSalesandCard: {
      color: "#800000",
      textAlign: "center",
      fontWeight: 500,
      border: "1px solid gray",
    },
    totalCellStyle: {
      borderLeft: "1px solid gray",
      borderBottom: "1px solid gray",
    },
    middleTotalcell: {
      borderBottom: "1px solid gray",
    },
    totalValueCell: {
      borderRight: "1px solid gray",
      borderBottom: "1px solid gray",
    },
    headCell: {
      color: "#000000",
      fontWeight: "bold",
      fontSize: "15px",
      border: "1px solid gray",
    },
    border: {
      border: "1px solid gray",
      padding: "2em",
    },
    content: {
      columnCount: 2,
      columnGap: "5%",
      //columnFill: "auto"
      
    },
     headerspace: {
      height: "1.5em",
    }, 
    footerspace: {
      height: "3em",
    },
    // styling for dynamic tables EOD
    tableContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gridGap: "3rem",
    },
    eodTable: {
      border: "1px solid #ccc",
      borderRadius: "1em",
      minWidth: 580,
    },
    tableHead: {
      backgroundColor: "#ffffff",
    },
    tableMainHead: {
      fontWeight: "bold",
      fontSize: "18px",
      color: theme.palette.primary.main,
    },
    tableSubHead: {
      backgroundColor: theme.palette.primary.light,
    },
    totalText: {
      fontWeight: "bold",
      fontSize: "15px",
    },
  })
);
